import { atom, useAtomValue, useSetAtom, useAtom } from "jotai";

export const isPDPLoadingAtom = atom(false);

const useIsPDPLoadingAtomValue = () => useAtomValue(isPDPLoadingAtom);
const useSetIsPDPLoadingAtom = () => useSetAtom(isPDPLoadingAtom);
const useIsPDPLoadingAtom = () => useAtom(isPDPLoadingAtom);

export {
  useIsPDPLoadingAtom,
  useSetIsPDPLoadingAtom,
  useIsPDPLoadingAtomValue
};
